<template>
  <div
    :id="`ups-${status.id}`"
    class="single-status"
    data-test-id="single-status"
  >
    <time-stamp
      class="single-status__timestamp"
      :date="status.insertedAt"
      format="dateAndTime"
    />
    <div class="single-status__box">
      <p
        class="single-status__text"
        v-html="formattedStatus"
      />
    </div>
    <status-engagement-bar
      :status="status"
      :limit="replyLimit"
    />
    <ol
      v-if="status.replies"
      class="single-status__replies list-reset"
    >
      <li
        v-for="(reply, index) in status.replies"
        :key="index"
      >
        <status-reply
          :id="`upsr-${reply.id}`"
          :reply="reply"
          :status="status"
          :limit="replyLimit"
        />
      </li>
    </ol>
  </div>
</template>

<script>
import TimeStamp from '@/components/Global/TimeStamp.vue';
import StatusEngagementBar from '@/components/User/Statuses/StatusEngagementBar.vue';
import StatusReply from '@/components/User/Statuses/StatusReply.vue';

export default {
  name: 'SingleStatus',
  components: {
    TimeStamp,
    StatusEngagementBar,
    StatusReply,
  },
  props: {
    status: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      replyLimit: 4,
    };
  },
  computed: {
    formattedStatus() {
      const pattern = /(.*)<img/;
      const hasImage = pattern.test(this.status.body);

      if (!this.status.body) {
        return '';
      }

      if (hasImage) {
        const statusText = this.status.body.match(pattern)[1];
        const newText = `"${statusText}"`;
        return this.status.body.replace(statusText, newText);
      }
      return `"${this.status.body}"`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_single-status';
</style>

<style lang="scss"> // no scoped - to reach class used in status
  @import '@/stylesheets/components/_uploaded-image';

  .single-status__text a:focus {
    @include highlighter-focus();
  }
</style>

<docs>
</docs>
